import Vue from 'vue'

/* ---------------------------------------------------------------------------------------------------------------------
 jQuery settings
---------------------------------------------------------------------------------------------------------------------- */

$.fn.form.settings.keyboardShortcuts = false
// $.fn.form.settings.revalidate = true;
$.fn.form.settings.inline = true
if (window.location.hostname === 'localhost') {
  $.fn.form.settings.debug = true // do not activate this in prod
}

jQuery.ajaxSetup({
  contentType: 'application/json; charset=utf-8',
  dataType: 'json'
})

/* ---------------------------------------------------------------------------------------------------------------------
 semantic-ui settings
---------------------------------------------------------------------------------------------------------------------- */

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

function validateEmail (email) {
  return EMAIL_REGEX.test(String(email).toLowerCase())
}

const INT_PHONE_PATTERN = new RegExp('^(\\+|00)[(),.\\s\\d-/]+$')

function validatePhone (phone) {
  return (phone !== null && phone.length >= 7 && phone.length <= 40 && INT_PHONE_PATTERN.exec(phone) !== null)
}

/** semantic-ui validation rule for a 'username' */
$.fn.form.settings.rules.username = function (value) {
  return validateEmail(value) || validatePhone(value)
}

/** semantic-ui validation rule for a 'username' */
$.fn.form.settings.rules.email = function (value) {
  return validateEmail(value)
}

/** semantic-ui validation rule for a 'password' */
$.fn.form.settings.rules.password = function (value) {
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#?!@$%^&*\-;:' +()"/.=>_])(?=.{8,256})/i.test(value) || value.length === 0
}

/** semantic-ui validation rule for a 'mobile' */
$.fn.form.settings.rules.mobile = function (value) {
  return validatePhone(value)
}

/* ---------------------------------------------------------------------------------------------------------------------
 Vue
---------------------------------------------------------------------------------------------------------------------- */

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

/* ---------------------------------------------------------------------------------------------------------------------
 other utilities
---------------------------------------------------------------------------------------------------------------------- */

/**
 * according to the Mozilla documentation
 * <a href="https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams">URLSearchParams</a>
 * does not exist in IE, so we define our oun
 */
export const CiamUrlParams = /* URLSearchParams ? URLSearchParams : */function (urlQuery) {
  return {
    url: urlQuery,
    get: function (name) {
      // console.log("URL: " + this.url)
      const parameter = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)').exec(this.url)
      return parameter ? decodeURIComponent(parameter[1]) : null
    },
    has: function (parameter) {
      return this.get(parameter) !== null
    },
    delete: function (name) {
      name = encodeURIComponent(name)
      this.url = this.url
        .replace(new RegExp('[?&]' + name + '=[^&#]*(#.*)?$'), '$1')
        .replace(new RegExp('([?&])' + name + '=[^&]*&'), '$1')
      console.debug('DEL ' + name)
    },
    toString: function () {
      // console.debug('toString: ' + this.url.toString());
      return this.url.toString()
    }
  }
}
